import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { ContentCopy } from "@mui/icons-material";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
import HelpIcon from "@mui/icons-material/Help";
import RefreshIcon from "@mui/icons-material/Refresh";
import { LoadingButton } from "@mui/lab";
import SendIcon from "@mui/icons-material/Send";

const PcStart = ({ client, user }) => {
  const { t } = useTranslation();
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage, showSuccessMessage, showWarningMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPcDetails, setIsLoadingPcDetails] = useState(false);
  const [powerState, setPowerState] = useState("off");
  const [pcInfos, setPcInfos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCycleModal, setShowCycleModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pcStarting, setPcStarting] = useState(false);

  // Stellt das Script auf test Modus. MUSS 0 SEIN BEIM UPDATE!
  const DEBUG = 0;
  const [debugSteckdose, setDebugSteckdose] = useState(0);

  useEffect(() => {
    checkPcState();
  }, []);

  useEffect(() => {
    if (powerState === "on") {
      fetchIp();
    }
  }, [powerState]);

  const fetchIp = () => {
    setIsLoadingPcDetails(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "PCIP_HOLEN",
      debug: DEBUG,
      debugSteckdose: debugSteckdose,
    };
    apiRequest("POST", "daten", payload, headers, ipCb, errorCb);
  };

  const ipCb = (response) => {
    setIsLoadingPcDetails(false);
    if (response.status === 200) {
      if (response.data.neueIp) {
        showWarningMessage(response.data.neueIp);
      }
      if (response.data.state) {
        setPowerState(response.data.state);
      }
      if (response.data.PC_INFOS) {
        setPcInfos(response.data.PC_INFOS);
      }
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const downloadFile = () => {
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "DATEI_LADEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        console.log(response.data);
        var contentFile = response.data;
        const mimeType = response.headers["Content-Type"] || "application/pdf";
        console.log(contentFile);
        openFile("Home-Office Anmeldung.pdf", contentFile, mimeType);
      })
      .catch(function (error) {
        console.log(error);
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den Download erneut.");
      });
  };

  const refresh = () => {
    checkPcState();
    if (powerState === "on") {
      fetchIp();
    }
  };

  const checkPcState = () => {
    setIsLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "CHECK_STATE",
      debug: DEBUG,
      debugSteckdose: debugSteckdose,
    };
    apiRequest("POST", "daten", payload, headers, stateCb, errorCb);
  };

  const stateCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.state) {
        setPowerState(response.data.state);
      }
      if (response.data.debugSteckdose) {
        setDebugSteckdose(response.data.debugSteckdose);
      }
      if (response.data.PC_INFOS) {
        setPcInfos(response.data.PC_INFOS);
      }
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const startPc = () => {
    setPcStarting(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "STARTEN",
      debug: DEBUG,
      debugSteckdose: debugSteckdose,
    };
    apiRequest("POST", "daten", payload, headers, openCb, errorCb);
  };

  const direktStopPc = () => {
    setShowModal(false);
    setIsLoading(true);
    setPcInfos([]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "DIREKT_STOPPEN",
      debug: DEBUG,
    };
    apiRequest("POST", "daten", payload, headers, openCb, errorCb);
  };

  const powerCycle = () => {
    setShowCycleModal(false);
    setIsLoading(true);
    setPcInfos([]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "POWER_CYCLE",
    };
    apiRequest("POST", "daten", payload, headers, openCb, errorCb);
  };

  const stopPc = () => {
    setShowConfirm(false);
    setPcInfos([]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: "PCRSHO",
      statement: "STOPPEN",
    };
    apiRequest("POST", "daten", payload, headers, openCb, errorCb);
  };

  const openCb = (response) => {
    setIsLoading(false);
    setPcStarting(false);
    checkPcState();

    if (response.status === 200) {
      showSuccessMessage(response.data.message);
      if (response.data.PC_INFOS) {
        setPcInfos(response.data.PC_INFOS);
      }
      if (response.data.debugSteckdose) {
        setDebugSteckdose(response.data.debugSteckdose);
      }
    } else {
      showErrorMessage(response.data.message);
    }
  };

  const errorCb = () => {
    setPcStarting(false);
    setIsLoading(false);
    showErrorMessage(t("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."));
  };

  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    showSuccessMessage("Kopieren erfolgreich");
  };

  return (
    <Page>
      <Layout>
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={12}>
            <Box sx={{ pt: 3, mr: 2, display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={downloadFile}>
                <HelpIcon></HelpIcon>
                <Typography sx={{ ml: 1 }}>{t("Hilfe")}</Typography>
              </Button>
            </Box>
            <Box p={2}>
              <Typography variant="h4">{t("Remote Steckdosen Steuerung")}</Typography>
              <Button onClick={refresh}>
                <RefreshIcon></RefreshIcon>
                <Typography sx={{ ml: 1 }}>{t("Refresh")}</Typography>
              </Button>
            </Box>
            <Box p={2}>
              {powerState === "off" && (
                <LoadingButton variant="contained" color="primary" loading={pcStarting} loadingPosition="end" fullWidth onClick={() => startPc()}>
                  <Typography variant="h5">{t("Strom einschalten")}</Typography>
                </LoadingButton>
              )}
              {powerState === "on" && (
                <Box p={2}>
                  <Dialog open={showConfirm} maxWidth="md" fullWidth>
                    <DialogContent>
                      <Typography variant="h5">
                        {t("Sind sie sicher das sie den Strom in 15 Minuten ausschalten wollen? Diese Aktion kann nicht mehr unterbrochen werden!")}
                      </Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button style={{ marginRight: "10px" }} color="primary" variant="secondary" display="flex" onClick={() => stopPc()}>
                        {t("Strom ausschalten")}
                      </Button>
                      <Button style={{ marginRight: "10px" }} color="primary" variant="contained" display="flex" onClick={() => setShowConfirm(false)}>
                        {t("Abbrechen")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Button variant="contained" color="primary" disabled={powerState !== "on"} fullWidth onClick={() => setShowConfirm(true)}>
                    <Typography variant="h5">{t("Strom in 15 Minuten ausschalten")}</Typography>
                  </Button>
                </Box>
              )}
            </Box>

            <Box p={2}>
              <Dialog open={showCycleModal} maxWidth="md" fullWidth>
                <DialogContent>
                  <Typography variant="h5">
                    {t(
                      "Dies sollte nicht gemacht werden wenn der Computer noch an sein könnte! Startet den Computer wenn dieser aus ist aber die Steckdose schon eingeschaltet ist.",
                    )}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button style={{ marginRight: "10px" }} color="primary" variant="secondary" display="flex" onClick={() => powerCycle()}>
                    {t("Strom neu starten")}
                  </Button>
                  <Button style={{ marginRight: "10px" }} color="primary" variant="contained" display="flex" onClick={() => setShowCycleModal(false)}>
                    {t("Abbrechen")}
                  </Button>
                </DialogActions>
              </Dialog>
              <Button variant="secondary" color="primary" disabled={powerState !== "on"} fullWidth onClick={() => setShowCycleModal(true)}>
                <Typography variant="h5">{t("Steckdose (PC) neu starten")}</Typography>
              </Button>
            </Box>

            <Box p={2}>
              <Dialog open={showModal} maxWidth="md" fullWidth>
                <DialogContent>
                  <Typography variant="h5">
                    {t("Sind sie sicher das sie den Strom direkt ausschalten wollen? Dies sollte nicht gemacht werden wenn der Computer noch an sein könnte!")}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button style={{ marginRight: "10px" }} color="primary" variant="secondary" display="flex" onClick={() => direktStopPc()}>
                    {t("Strom ausschalten")}
                  </Button>
                  <Button style={{ marginRight: "10px" }} color="primary" variant="contained" display="flex" onClick={() => setShowModal(false)}>
                    {t("Abbrechen")}
                  </Button>
                </DialogActions>
              </Dialog>
              <Button variant="secondary" color="primary" disabled={powerState !== "on"} fullWidth onClick={() => setShowModal(true)}>
                <Typography variant="h5">{t("Strom sofort ausschalten (nur im Notfall)")}</Typography>
              </Button>
            </Box>
          </Grid>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow key="kinder">
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 1,
                      }}
                    >
                      <Typography>{t("PC Informationen")}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(pcInfos).map((item) => {
                  return (
                    <TableRow key={item}>
                      <TableCell>{item}</TableCell>

                      <TableCell>
                        <Typography variant="h6">{pcInfos[item]}</Typography>
                      </TableCell>

                      {item !== "IP" && <TableCell></TableCell>}
                      {item === "IP" && (
                        <TableCell>
                          <IconButton color="primary" onClick={() => handleCopy(pcInfos[item])}>
                            <ContentCopy />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Layout>
      {isLoading && (
        <Layout>
          <Grid className="m-6" container justifyContent="center" alignItems="center" spacing={1}>
            <Grid item xs={12}>
              <Box
                className="pt-6"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 1,
                }}
              >
                <Typography variant="h5">{t("Status wird geladen")}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Layout>
      )}

      {isLoadingPcDetails && (
        <Layout>
          <Grid className="m-6" container justifyContent="center" alignItems="center" spacing={1}>
            <Grid item xs={12}>
              <Box
                className="pt-6"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 1,
                }}
              >
                <Typography variant="h5">{t("PC wird gestartet. Bitte warten!")}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Layout>
      )}

      {powerState === "pending" && (
        <Layout>
          <Grid className="m-6" container justifyContent="center" alignItems="center" spacing={1}>
            <Grid item xs={12}>
              <Box
                className="pt-6"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 1,
                }}
              >
                <Typography variant="h5">{t("Steckdosen Status wird geändert...")}</Typography>
              </Box>
            </Grid>
          </Grid>
        </Layout>
      )}
    </Page>
  );
};

export default PcStart;
